import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyC3wZIFC5KruEZwIgblLYm6OUG4A5U9HBo",
  authDomain: "sura-751c0.firebaseapp.com",
  projectId: "sura-751c0",
  storageBucket: "sura-751c0.firebasestorage.app",
  messagingSenderId: "928318287625",
  appId: "1:928318287625:web:4df814a1094cae57036dd8",
  measurementId: "G-2DR9NH8WE3",
};

const app = initializeApp(firebaseConfig);
export default app;
